import { Component, defineComponent } from 'vue';

import Banner from '../Banner.vue';

export default defineComponent({
	components: {
		Banner: Banner as Component
	},
	props: {
		bannerIds: Array<string>,
		type: String,
		cssClass: String
	}
});
